/* eslint-disable */

// @ts-nocheck

// This file was automatically generated by @icp-sdk/bindgen@0.3.0.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import {IDL} from '@icp-sdk/core/candid';

export const Value = IDL.Rec();
export const UpgradeArg = IDL.Record({
  ledger_id: IDL.Opt(IDL.Principal),
  retrieve_blocks_from_ledger_interval_seconds: IDL.Opt(IDL.Nat64)
});
export const InitArg = IDL.Record({
  ledger_id: IDL.Principal,
  retrieve_blocks_from_ledger_interval_seconds: IDL.Opt(IDL.Nat64)
});
export const IndexArg = IDL.Variant({
  Upgrade: UpgradeArg,
  Init: InitArg
});
export const BlockIndex = IDL.Nat;
export const SubAccount = IDL.Vec(IDL.Nat8);
export const Account = IDL.Record({
  owner: IDL.Principal,
  subaccount: IDL.Opt(SubAccount)
});
export const GetAccountTransactionsArgs = IDL.Record({
  max_results: IDL.Nat,
  start: IDL.Opt(BlockIndex),
  account: Account
});
export const Tokens = IDL.Nat;
export const Burn = IDL.Record({
  fee: IDL.Opt(IDL.Nat),
  from: Account,
  memo: IDL.Opt(IDL.Vec(IDL.Nat8)),
  created_at_time: IDL.Opt(IDL.Nat64),
  amount: Tokens,
  spender: IDL.Opt(Account)
});
export const Mint = IDL.Record({
  to: Account,
  fee: IDL.Opt(IDL.Nat),
  memo: IDL.Opt(IDL.Vec(IDL.Nat8)),
  created_at_time: IDL.Opt(IDL.Nat64),
  amount: Tokens
});
export const Approve = IDL.Record({
  fee: IDL.Opt(Tokens),
  from: Account,
  memo: IDL.Opt(IDL.Vec(IDL.Nat8)),
  created_at_time: IDL.Opt(IDL.Nat64),
  amount: Tokens,
  expected_allowance: IDL.Opt(Tokens),
  expires_at: IDL.Opt(IDL.Nat64),
  spender: Account
});
export const FeeCollector = IDL.Record({
  ts: IDL.Opt(IDL.Nat64),
  mthd: IDL.Opt(IDL.Text),
  fee_collector: IDL.Opt(Account),
  caller: IDL.Opt(IDL.Principal)
});
export const Transfer = IDL.Record({
  to: Account,
  fee: IDL.Opt(Tokens),
  from: Account,
  memo: IDL.Opt(IDL.Vec(IDL.Nat8)),
  created_at_time: IDL.Opt(IDL.Nat64),
  amount: Tokens,
  spender: IDL.Opt(Account)
});
export const Transaction = IDL.Record({
  burn: IDL.Opt(Burn),
  kind: IDL.Text,
  mint: IDL.Opt(Mint),
  approve: IDL.Opt(Approve),
  fee_collector: IDL.Opt(FeeCollector),
  timestamp: IDL.Nat64,
  transfer: IDL.Opt(Transfer)
});
export const TransactionWithId = IDL.Record({
  id: BlockIndex,
  transaction: Transaction
});
export const GetTransactions = IDL.Record({
  balance: Tokens,
  transactions: IDL.Vec(TransactionWithId),
  oldest_tx_id: IDL.Opt(BlockIndex)
});
export const GetTransactionsErr = IDL.Record({message: IDL.Text});
export const GetTransactionsResult = IDL.Variant({
  Ok: GetTransactions,
  Err: GetTransactionsErr
});
export const GetBlocksRequest = IDL.Record({
  start: IDL.Nat,
  length: IDL.Nat
});
export const Map = IDL.Vec(IDL.Tuple(IDL.Text, Value));
Value.fill(
  IDL.Variant({
    Int: IDL.Int,
    Map: Map,
    Nat: IDL.Nat,
    Nat64: IDL.Nat64,
    Blob: IDL.Vec(IDL.Nat8),
    Text: IDL.Text,
    Array: IDL.Vec(Value)
  })
);
export const Block = Value;
export const GetBlocksResponse = IDL.Record({
  blocks: IDL.Vec(Block),
  chain_length: IDL.Nat64
});
export const FeeCollectorRanges = IDL.Record({
  ranges: IDL.Vec(IDL.Tuple(Account, IDL.Vec(IDL.Tuple(BlockIndex, BlockIndex))))
});
export const ListSubaccountsArgs = IDL.Record({
  owner: IDL.Principal,
  start: IDL.Opt(SubAccount)
});
export const Status = IDL.Record({num_blocks_synced: BlockIndex});

export const idlService = IDL.Service({
  get_account_transactions: IDL.Func(
    [GetAccountTransactionsArgs],
    [GetTransactionsResult],
    ['query']
  ),
  get_blocks: IDL.Func([GetBlocksRequest], [GetBlocksResponse], ['query']),
  get_fee_collectors_ranges: IDL.Func([], [FeeCollectorRanges], ['query']),
  icrc1_balance_of: IDL.Func([Account], [Tokens], ['query']),
  ledger_id: IDL.Func([], [IDL.Principal], ['query']),
  list_subaccounts: IDL.Func([ListSubaccountsArgs], [IDL.Vec(SubAccount)], ['query']),
  status: IDL.Func([], [Status], ['query'])
});

export const idlInitArgs = [IDL.Opt(IndexArg)];

export const idlFactory = ({IDL}) => {
  const Value = IDL.Rec();
  const UpgradeArg = IDL.Record({
    ledger_id: IDL.Opt(IDL.Principal),
    retrieve_blocks_from_ledger_interval_seconds: IDL.Opt(IDL.Nat64)
  });
  const InitArg = IDL.Record({
    ledger_id: IDL.Principal,
    retrieve_blocks_from_ledger_interval_seconds: IDL.Opt(IDL.Nat64)
  });
  const IndexArg = IDL.Variant({Upgrade: UpgradeArg, Init: InitArg});
  const BlockIndex = IDL.Nat;
  const SubAccount = IDL.Vec(IDL.Nat8);
  const Account = IDL.Record({
    owner: IDL.Principal,
    subaccount: IDL.Opt(SubAccount)
  });
  const GetAccountTransactionsArgs = IDL.Record({
    max_results: IDL.Nat,
    start: IDL.Opt(BlockIndex),
    account: Account
  });
  const Tokens = IDL.Nat;
  const Burn = IDL.Record({
    fee: IDL.Opt(IDL.Nat),
    from: Account,
    memo: IDL.Opt(IDL.Vec(IDL.Nat8)),
    created_at_time: IDL.Opt(IDL.Nat64),
    amount: Tokens,
    spender: IDL.Opt(Account)
  });
  const Mint = IDL.Record({
    to: Account,
    fee: IDL.Opt(IDL.Nat),
    memo: IDL.Opt(IDL.Vec(IDL.Nat8)),
    created_at_time: IDL.Opt(IDL.Nat64),
    amount: Tokens
  });
  const Approve = IDL.Record({
    fee: IDL.Opt(Tokens),
    from: Account,
    memo: IDL.Opt(IDL.Vec(IDL.Nat8)),
    created_at_time: IDL.Opt(IDL.Nat64),
    amount: Tokens,
    expected_allowance: IDL.Opt(Tokens),
    expires_at: IDL.Opt(IDL.Nat64),
    spender: Account
  });
  const FeeCollector = IDL.Record({
    ts: IDL.Opt(IDL.Nat64),
    mthd: IDL.Opt(IDL.Text),
    fee_collector: IDL.Opt(Account),
    caller: IDL.Opt(IDL.Principal)
  });
  const Transfer = IDL.Record({
    to: Account,
    fee: IDL.Opt(Tokens),
    from: Account,
    memo: IDL.Opt(IDL.Vec(IDL.Nat8)),
    created_at_time: IDL.Opt(IDL.Nat64),
    amount: Tokens,
    spender: IDL.Opt(Account)
  });
  const Transaction = IDL.Record({
    burn: IDL.Opt(Burn),
    kind: IDL.Text,
    mint: IDL.Opt(Mint),
    approve: IDL.Opt(Approve),
    fee_collector: IDL.Opt(FeeCollector),
    timestamp: IDL.Nat64,
    transfer: IDL.Opt(Transfer)
  });
  const TransactionWithId = IDL.Record({
    id: BlockIndex,
    transaction: Transaction
  });
  const GetTransactions = IDL.Record({
    balance: Tokens,
    transactions: IDL.Vec(TransactionWithId),
    oldest_tx_id: IDL.Opt(BlockIndex)
  });
  const GetTransactionsErr = IDL.Record({message: IDL.Text});
  const GetTransactionsResult = IDL.Variant({
    Ok: GetTransactions,
    Err: GetTransactionsErr
  });
  const GetBlocksRequest = IDL.Record({
    start: IDL.Nat,
    length: IDL.Nat
  });
  const Map = IDL.Vec(IDL.Tuple(IDL.Text, Value));
  Value.fill(
    IDL.Variant({
      Int: IDL.Int,
      Map: Map,
      Nat: IDL.Nat,
      Nat64: IDL.Nat64,
      Blob: IDL.Vec(IDL.Nat8),
      Text: IDL.Text,
      Array: IDL.Vec(Value)
    })
  );
  const Block = Value;
  const GetBlocksResponse = IDL.Record({
    blocks: IDL.Vec(Block),
    chain_length: IDL.Nat64
  });
  const FeeCollectorRanges = IDL.Record({
    ranges: IDL.Vec(IDL.Tuple(Account, IDL.Vec(IDL.Tuple(BlockIndex, BlockIndex))))
  });
  const ListSubaccountsArgs = IDL.Record({
    owner: IDL.Principal,
    start: IDL.Opt(SubAccount)
  });
  const Status = IDL.Record({num_blocks_synced: BlockIndex});

  return IDL.Service({
    get_account_transactions: IDL.Func(
      [GetAccountTransactionsArgs],
      [GetTransactionsResult],
      ['query']
    ),
    get_blocks: IDL.Func([GetBlocksRequest], [GetBlocksResponse], ['query']),
    get_fee_collectors_ranges: IDL.Func([], [FeeCollectorRanges], ['query']),
    icrc1_balance_of: IDL.Func([Account], [Tokens], ['query']),
    ledger_id: IDL.Func([], [IDL.Principal], ['query']),
    list_subaccounts: IDL.Func([ListSubaccountsArgs], [IDL.Vec(SubAccount)], ['query']),
    status: IDL.Func([], [Status], ['query'])
  });
};

export const init = ({IDL}) => {
  const UpgradeArg = IDL.Record({
    ledger_id: IDL.Opt(IDL.Principal),
    retrieve_blocks_from_ledger_interval_seconds: IDL.Opt(IDL.Nat64)
  });
  const InitArg = IDL.Record({
    ledger_id: IDL.Principal,
    retrieve_blocks_from_ledger_interval_seconds: IDL.Opt(IDL.Nat64)
  });
  const IndexArg = IDL.Variant({Upgrade: UpgradeArg, Init: InitArg});

  return [IDL.Opt(IndexArg)];
};
